import React from 'react'

export default function LoadingComponent (props) {
  if (props.isLoading) {
    // While our other component is loading...
    if (props.timedOut) {
      // In case we've timed out loading our other component.
      return <div>Loader timed out!</div>
    } else if (props.pastDelay) {
      // Display a loading screen after a set delay. <img src="/logo.svg" className="loader" alt="logo" />
      return <div className='shell'>
        <div className='container'>
          <img src='/logo.svg' className='loader' alt='logo' />
        </div>
      </div>
    } else {
      // Don't flash "Loading..." when we don't need to.
      return null
    }
  } else if (props.error) {
    window.location.reload()
    // If we aren't loading, maybe
    return <div>Error! Component failed to load</div>
  } else {
    // This case shouldn't happen... but we'll return null anyways.
    return null
  }
}



// WEBPACK FOOTER //
// ./src/components/LoadingComponent/LoadingComponent.js